import { apiFetch } from "./client";
import type { AuditLog, Page } from "./types";
import type { ListParams } from "./customers";

export interface AuditParams extends ListParams {
  entity_type?: string;
  entity_id?: string;
  actor_user_id?: number;
}

export async function listAudit(params: AuditParams = {}): Promise<Page<AuditLog>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  if (params.entity_type) qs.set("entity_type", params.entity_type);
  if (params.entity_id) qs.set("entity_id", params.entity_id);
  if (params.actor_user_id !== undefined) qs.set("actor_user_id", String(params.actor_user_id));
  const query = qs.toString();
  return apiFetch(`/audit${query ? `?${query}` : ""}`);
}

export async function getAudit(id: number): Promise<AuditLog> {
  return apiFetch<AuditLog>(`/audit/${id}`);
}
